export class SearchEntity {
  AgentID?: string;
  Activity?: any
  PageNo: number;
  PageSize: number;
  SortOrder: string;
  SortBy: string;
}

export interface IGridSettings {
  title: string;
  columns: GridColumn[];
  showDropdownFilter: boolean;
  showDurationDropdownFilter?: boolean;
  showIndex: boolean;
  showDownload?: boolean;
  showViewDetails?: boolean;
  showPagination?: boolean;
  showDelete?: boolean;
  showInformationPopover?: boolean;
  showDateRangePicker?: boolean;
}

export class GridColumn {

  constructor() {
    this.show = true;
    this.sort = false;
    this.type = null;
  }

  show: boolean;
  name: string;
  title: string;
  type?: ColumnType;
  sort: boolean;
  filterType?: string;
}

export class PaginationSetting {
  public totalRecords: number;
  public currentPage: number;
  public itemPerPage: number;
  selectedPageSize?: string[];

  constructor() {
    this.currentPage = 1;
  }
}

export enum SortOrder {
  ASC = "ASC",
  DESC = "DESC",
  Default = "Default"
}

export enum ColumnType {
  INFO = "INFO",
  SHORTDATE = "SHORTDATE",
  STATUS = "STATUS",
  CURRENCY = "CURRENCY",
  VIEW = "VIEW",
  DOWNLOAD = "DOWNLOAD",
  LONGDATE = "LONGDATE",
  STATUSCOLUMN = "STATUSCOLUMN",
  BOOLEAN = "BOOLEAN"
}

export class ListItem {
  id: String;
  text: String;

  public constructor(source: any) {
    if (typeof source === 'string') {
      this.id = this.text = source;
    }
    if (typeof source === 'object') {
      this.id = source.id;
      this.text = source.text;
    }
  }
}

export class SortConfiguration {
  constructor() {
    this.sort = "";
  }
  sort: string;
  sortOrder: SortOrder;
}
